import { Code2 } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-muted/50 border-t border-border/50 py-12">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-2 text-foreground">
              <img src="/favicon-32x32.png" alt="Logo Erm-media" />
            <span className="font-bold text-lg">erm-media</span>
          </div>

          <p className="text-sm text-muted-foreground text-center">
            © {new Date().getFullYear()} erm-media. Todos los derechos reservados.
          </p>

          <div className="flex items-center gap-6">
            <a href="/quienes-somos" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
              Quiénes Somos
            </a>
            <a href="/privacidad" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
              Privacidad
            </a>
            <a href="/terminos" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
              Términos
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
